import { Container, Link, useMediaQuery, useTheme } from "@mui/material";
import { Link as InertiaLink } from "@inertiajs/react";
import { default as MuiBreadcrumbs } from "@mui/material/Breadcrumbs";

interface IProps {
    breadcrumbs: powerready.IBreadcrumb[];
}

const Breadcrumbs: React.FC<IProps> = ({ breadcrumbs }) => {
    const theme = useTheme();
    const isMobilePhone = useMediaQuery(theme.breakpoints.down("sm"));

    const crumbs = breadcrumbs.filter((b) => !!b.title);

    if (!crumbs || crumbs.length < 2) {
        return null;
    }

    return (
        <Container
            sx={{
                borderBottom: `1px solid ${theme.palette.secondary.dark}`,
                bgcolor: "white",
                mx: 0,
                maxWidth: "100%",
                minWidth: "100%",
                py: 1,
            }}
        >
            <MuiBreadcrumbs
                separator="/"
                aria-label="breadcrumb"
                sx={{
                    fontFamily: "OpenSans",
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "16px",
                }}
            >
                {crumbs.map((b, i) => (
                    <Link
                        component={InertiaLink}
                        underline={b.href ? "always" : "none"}
                        key={(i + 1).toString()}
                        href={b.href || "#"}
                        color={b.href ? undefined : "secondary.dark"}
                        sx={{
                            cursor: b.href ? "pointer" : "auto",
                            fontFamily: "OpenSans",
                            fontSize: "12px",
                            fontWeight: 600,
                            lineHeight: "16px",
                        }}
                        variant={isMobilePhone ? "caption" : undefined}
                    >
                        {b.title}
                    </Link>
                ))}
            </MuiBreadcrumbs>
        </Container>
    );
};

export default Breadcrumbs;
